import Home from '@/views/Home.vue'

import SignIn from '@/views/auth/SignIn.vue'
import SignUp from '@/views/auth/SignUp.vue'
import Welcome from '@/views/auth/Welcome.vue'
import ChangePassword from '@/views/auth/ChangePassword.vue'

const authRoutes = [
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: { auth: false }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { auth: true }
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
    meta: { auth: false }
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp,
    meta: { auth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { auth: true, roles: [] }
  },
]

const commonUsersRoutes = [
  // Add routes common for all users here
].map(route => ({
  ...route,
  meta: {
    auth: true,
    roles: []
  }
}))

export default [
  ...authRoutes,
  ...commonUsersRoutes,
]